import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string | null, format?: string) {
    if (!format) {
      format = 'dd MMMM y';
    }
    var datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, format);
    return value;
  }
}
